import React, { useState, useEffect } from 'react';
import { userForgotPassword } from '../../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { validatePhone } from '../../shared/validation';
import { actionNotifier } from '../../components/tostify';
import { FormControl, TextField } from '../../imports/muiImport';
import ErrorMsg from '../../components/errorMsg/ErrorMsg';
import BasicBtn from "../../components/button/BasicBtn";

const ForgetPassword = ({ handleUserForm, setIsUserAuthentic }) => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const [mobileError, setMobileError] = useState({ status: false, message: '' });

  // ErrorMsg state
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('error');

  // Auto-close alert after 3s
  useEffect(() => {
    let timer;
    if (alertOpen) {
      timer = setTimeout(() => setAlertOpen(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [alertOpen]);

  const showAlert = (message, severity = 'error') => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const phoneHandler = (e) => {
    setMobile(e.target.value.replace(/\D/g, '')); // Only digits
    setMobileError({ status: false, message: '' });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validation = validatePhone(mobile);
    if (!validation.status) {
      setMobileError({ status: true, message: validation.message });
      showAlert(validation?.message);
      setLoading(false);
      return;
    }

    await handleForgot(mobile);
    setLoading(false);
  };

  const handleForgot = async (mobile) => {
    try {
      const response = await userForgotPassword(mobile);

      if (response?.status) {
        actionNotifier.success('OTP sent successfully.', {
          position: 'top-center',
          autoClose: 1500,
        });

        setIsUserAuthentic({
          mobile,
          token: null,
          status: true,
        });

        handleUserForm('USERPHONEFORMFILLSUCCESSFUL');
        setMobile('');
      } else {
        showAlert(response?.message || 'Something went wrong');
      }
    } catch (error) {
      showAlert('Server error. Please try again later.');
    }
  };

  return (
    <>
      {/* Global Error Alert */}
      <ErrorMsg
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        message={alertMessage}
        severity={alertSeverity}
        height={1}
      />

      {/* Form */}
      <FormControl
        component="form"
        method="POST"
        onSubmit={handleFormSubmit}
        fullWidth
        sx={{mt:3}}
      >
        <TextField
          variant="outlined"
          placeholder="Enter your Mobile Number"
          fullWidth
          value={mobile}
          onChange={phoneHandler}
          inputProps={{
            maxLength: 10,
            pattern: "\\d{10}",
          }}
          sx={{
            marginBottom: 4,
            backgroundColor: 'white.main',
            borderRadius: '10px',
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
            },
          }}
          error={mobileError.status}
          helperText={mobileError.message}
          focused={mobileError.status}
          color="error"
        />

        <BasicBtn
          type="submit"
          name="Submit"
          color="secondary"
          smColor="primary"
          loading={loading}
          disabled={loading}
          sx={{ mt: 3 }}
        />
      </FormControl>
    </>
  );
};

export default ForgetPassword;
